// Maps every i18n namespace to the real page it belongs to, so the admin
// "Website" nav section mirrors the actual site structure instead of one
// flat searchable list. Every namespace must appear in exactly one entry —
// unmapped namespaces fall under Settings so nothing is orphaned.
export interface AdminPageConfig {
  slug: string;
  title: string;
  namespaces: string[];
}

export const ADMIN_PAGES: AdminPageConfig[] = [
  { slug: 'settings', title: 'Settings', namespaces: ['common', 'cart', 'stickyBar'] },
];

// Deliberately NOT admin-editable: transactional/functional pages, not
// marketing copy (Verify, Login & Register, My Account, Checkout, Order
// Confirmation) — confirmed with the business owner. Their i18n namespaces
// ('verify', 'auth', 'my', 'checkout', 'order') stay only in the bundled
// en/ko/bn defaults, with no rxk_site_content override UI.
//
// 'nav' and 'footer' are also deliberately absent — Header & Footer moved
// to their own dedicated editor (admin/website/header-footer/page.tsx),
// which manages the actual link structure (rxk_nav_links/rxk_footer_*)
// alongside the leftover standalone text (brand description, disclosure
// lines, copyright) that still lives in rxk_site_content under these
// namespaces. Editing them here too would just be a second, conflicting
// place to change the same rows.
//
// 'home', 'brandStory', 'threeStep', 'products', 'whereToBuy', 'about',
// 'contact', 'faq', 'privacy', 'terms', 'shipping', 'partnerApply', and
// 'content' are likewise absent — each moved to its own dedicated editor
// under admin/website/*-page/page.tsx, organized by the page's actual
// sections (with per-section show/hide and image upload where relevant)
// instead of one flat list of every key. Only 'settings' remains here —
// a bundle of shared strings (common/cart/stickyBar) with no natural
// page sections to organize by.
